import { PageComponent } from "barba";

class Video {
    constructor({ node }) {
        this.video = node;
        this.queryString = "";
        this.clicked = false;
        this.clickHandler = this.click.bind(this);

        this.poster = this.video.querySelector("[data-video-poster]");

        this.autoplay = this.video.dataset.videoAutoplay === "True";
        this.loop = this.video.dataset.videoLoop === "True";

        if (this.autoplay) {
            this.initializeVideo();
        } else {
            this.video.addEventListener("click", this.clickHandler);
        }
    }

    click(e) {
        const btn = e.target.closest("[data-video-button]");

        if (!btn) {
            return;
        }

        this.initializeVideo();

        this.clicked = true;
        e.preventDefault();
        return false;
    }

    initializeVideo() {
        let videoId = this.video.dataset.videoId;

        if (!videoId) {
            return;
        }

        let poster = this.video.querySelector("[data-video-poster]");

        if (poster) {
            poster.classList.add("hidden");
        }

        let iframe = document.createElement("iframe");
        let videoType = this.video.dataset.videoType;
        let paramsQuery = `?autoplay=1&${this.loop ? "loop=1" : ""}`;

        if (videoType === "Youtube") {
            iframe.src = `https://www.youtube.com/embed/${videoId}${paramsQuery}${this.autoplay ? "&controls=0&mute=1" : ""}`;
        } else if (videoType === "Vimeo") {
            iframe.src = `https://player.vimeo.com/video/${videoId}${paramsQuery}${
                this.autoplay ? "&background=1&autopause=0" : ""
            }`;
        }

        iframe.width = 560;
        iframe.width = 315;
        iframe.frameBorder = 0;
        iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowfullscreen = "";

        this.video.appendChild(iframe);
    }

    destroy() {
        this.video.removeEventListener("click", this.clickHandler);
        delete this.video;
        delete this.clicked;
        delete this.clickHandler;
        delete this.autoplay;
        delete this.loop;
    }
}

new PageComponent("[data-video]", Video);
